import React from 'react';
import { Box, Page } from '@wix/design-system';
import { CollectionPageHeaderElement } from '../../components/CollectionPageHeaderNew';

export function useCollectionPageHeader(child: CollectionPageHeaderElement) {
  return (
    <Page.Header
      key={child.key}
      dataHook="collection-page-header"
      title={child.props.title.text}
      subtitle={child.props.subtitle?.text}
      actionsBar={
        <Box gap="SP2">
          {child.props.moreActions}
          {child.props.primaryAction}
        </Box>
      }
      breadcrumbs={child.props.breadcrumbs}
    />
  );
}
